import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const FixedButtonsContainer = ({ children }) => {
  // Check URL pattern for campaign creation pages (both new and existing campaigns)
  // Supports /engagement-v2/... and /barber/engagement-v2/... and /brand/engagement-v2/...
  const isOnCreatingNewCampaignPage = /\/engagement-v2\/(?:new|[^/]+)\/(?:type|configuration|content|review)/.test(
    window.location.pathname
  );

  return (
    <div className={classNames('c-btn--fixed-container', { 'c-btn--on-new-campaign': isOnCreatingNewCampaignPage })}>
      {children}
    </div>
  );
};

FixedButtonsContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FixedButtonsContainer;
